import React from 'react'
import { ArrowLeft } from 'lucide-react'

const ModuleViewBackLink = ({ onClick, label = 'Back to transactions' }) => (
  <button type="button" className="module-view-back-link" onClick={onClick}>
    <ArrowLeft size={16} />
    <span>{label}</span>
  </button>
)

export default ModuleViewBackLink
